








































































































































  import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { AuthService } from './services/authService';

  import axios from 'axios';
import Snackbar from './types/app/snackbar';
import User from './types/auth/user';

  @Component({})
  export default class App extends Vue {
    authService = new AuthService();
    instance = axios.create();

    @Getter('getUser', { namespace: 'auth' }) user!: User;
    @Getter('getSnackbar', { namespace: 'app' }) snackbar!: Snackbar;
    @Getter('getOverlay', { namespace: 'app' }) overlay!: boolean;

    @Action('setUser', { namespace: 'auth' }) setUser: any;
    @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

    gettingMenu = false;
    drawer = false;
    imgUrl = '';
    menu = false;

    async created() {
      await this.initialize();
      this.setActive();
    }

    async initialize(): Promise<void> {
      if (this.$route.name !== 'Logout' && this.$route.name !== 'Login') {
        const userData = this.authService.getTokenData();

        this.setUser(userData);
        await this.getGraphToken();
      }
    }

    active(route: string): boolean {
      return this.$route.name === route || this.$route.meta?.before === route;
    }

    setActive(): void {
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].active = this.items[i].title === this.$route.meta?.parent;
      }
    }

    async getGraphToken(): Promise<void> {
      const graphToken = await this.authService.getTokenGraph();
      if (graphToken != null) {
        try {
          const resp = await this.instance({
            method: 'get',
            url: 'https://graph.microsoft.com/v1.0/me/photos/48x48/$value',
            responseType: 'blob',
            headers: { Authorization: `Bearer ${graphToken}` }
          });

          this.imgUrl = URL.createObjectURL(resp.data);
        } catch (error) {
          this.imgUrl = require('./assets/avatar.png');
        }
      } else {
        this.imgUrl = require('./assets/avatar.png');
      }
    }

    goTo(route: string): void {
      this.$router.push({ name: route });
    }

    logout(): void {
      this.authService.logoutAsync();
    }

    cleanCache(): void {
      this.$router.push({ name: 'Home' });
    }

    closeSnackbar(): void {
      this.setSnackbar({
        show: false,
        color: '',
        message: ''
      });
    }

    items = [
      {
        title: 'Management',
        action: 'mdi-account-edit',
        active: false,
        menus: [
          {
            title: 'Users',
            index: 'IndexUser',
            create: 'FormUser',
            detail: 'FormUser',
            controller: 'User',
            permissions: [
              { action: 'GetByFilter', active: true },
              { action: 'GetByExport', active: true },
              { action: 'Create', active: true },
              { action: 'Update', active: true },
              { action: 'Delete', active: true },
              { action: 'GetById', active: true }
            ]
          },
          {
            title: 'Profiles',
            index: 'IndexProfile',
            create: 'FormProfile',
            detail: 'FormProfile',
            controller: 'Profile',
            permissions: [
              { action: 'GetByFilter', active: true },
              { action: 'GetByExport', active: true },
              { action: 'Create', active: true },
              { action: 'Update', active: true },
              { action: 'Delete', active: true },
              { action: 'GetById', active: true }
            ]
          }
        ]
      }
    ];
  }
